import React, { useRef } from "react";

import "./style/formContato.css";
import "./style/sobrenos.css" 

import { send } from 'emailjs-com';

const FormContato = () => {
      const form = useRef();
    
      const onSubmit = (e) => {
        e.preventDefault();
    
        send(
          'service_mxjpfr9',
          'template_q4avvqs',
          form.current,
          'user_9Ct6rnprjW7Uufix72OsD'
        )
          .then((response) => {
            console.log('SUCCESS!', response.status, response.text);
            window.location.reload();
          })
          .catch((err) => {
            console.log('FAILED...', err);
          });
          
      };

    return (
       <div>
           <div className="container-f" id="Contato">
                <h8 data-aos="fade-up" data-aos-duration="1000">ENTRE EM CONTATO</h8>
            <div className="content">
                    <div className="content_info">
                        <p className="text_info" data-aos="fade-up" data-aos-duration="1500" >
                            <b style={{textTransform:'uppercase'}}>Plantão de Vendas</b> <br/>
                            Al Prudente de Moraes, 298 Mercês<br/>
                            <br/>
                            <b style={{textTransform:'uppercase'}}>Entre em contato pelo WhatsApp</b> <br/>
                            <a href="https://api.whatsapp.com/send?phone=5541996480900" style={{color:'inherit'}}>41 99648.0900 </a><br/>
                            <br/>
                            <b style={{textTransform:'uppercase'}}>Siga-nos no Instagram</b> <br/>
                            <a style={{color:'inherit'}}href="https://www.instagram.com/concrezatto_construtora/?igshid=OTJlNzQ0NWM%3D">@concrezatto_construtora </a><br/>
                            <br/>
                            <b style={{textTransform:'uppercase'}}>Venda exclusiva</b> <br/>
                            Concrezatto Construtora<br/>
                        </p>
                    </div>
                   <div style={{marginBottom:'4rem'}}>
                    <h8 style={{paddingTop: '0px', display: 'block', marginTop: '0px'}}>Link direto para<br/> nosso WhatsApp!</h8>
                    <a href="https://api.whatsapp.com/send?phone=5541996480900" className="custom-btn btn-15 aos-init aos-animate" style={{color: 'black', borderColor: 'black', textAlign: 'center', fontSize: '1.3rem', marginTop: '1rem'}}>
                      <img src="whatsapp-logo_icon-icons.com_57054.png" style={{width: '25px', marginRight: '10px', marginBottom: 'auto'}} />
                      WhatsApp
                    </a>
                  </div>                    
            </div>
            <p style={{maxWidth: '60vw', textAlign: "justify", opacity: '50%'}}>
                Imagens meramente ilustrativas. Mobiliário/eletrônicos não inclusos. Possíveis
                 alterações de projeto podem ocorrer.  Consulte memorial descritivo do empreendimento.
                   Valores/condições sujeitos a alteração sem prévio aviso. Matrícula 57473 - 1ª Circunscrição de Curitiba.
            </p>
            <a href="/politicaDePrivacidade" style={{fontFamily:'Montserrat, sans-serif', color:'black'}}>Política de Privacidade</a>
        </div>
       </div>
    )
}

export default FormContato;
